import React, { useContext, useEffect, useRef } from 'react';
import HDateTime, { HTime, HTimeFormat } from "../lib/HDateTime.js";
import { useState } from 'react';
import { SpikerBoardContext } from '../context/SpikerBoardContext.js';


export default function SB_TitleBar() {
    const [timeNow, setTimeNow] = useState(HTime.Parse("00:00:00"));
    const [competitionTime, setCompetitionTime] = useState(HTime.Parse("00:00:00"));
    const [competitionStart, setCompetitionStart] = useState(HTime.Parse("00:00:00"));
    const eventStartTime = useRef(null);

    const [spikerBoardContext, setSpikerBoardContext] = useContext(SpikerBoardContext);
    useEffect(() => {
        //on load
        var t = spikerBoardContext.eventSettings.starttime;
        if (t == null) return;
        var time = HTime.Parse(t);
        eventStartTime.current = time;
        setCompetitionStart(eventStartTime.current);
    }, [spikerBoardContext.eventSettings.starttime]);
    useEffect(() => {
        //console.log("HTime:: ", eventStartTime.current);
        //1 second tick
        setTimeout(() => {

            let tnow = new HTime();
            setTimeNow(tnow);
            if (spikerBoardContext.eventSettings.starttime == null) return;
            let ct = HTime.Diff(tnow, eventStartTime.current);
            setCompetitionTime(ct);
        }, 1000);
    }, [timeNow]);

    return (
        <div className="h-36">
            <div className='grid grid-cols-12 h-full gap-2' >
                <div className='col-span-9 rounded-xl bg-gray-100 p-2'>
                    {spikerBoardContext.event.Name}
                </div>
                <div className='col-span-3 rounded-xl bg-gray-100 p-2'>
                    <div className='grid h-full grid-cols-2 gap-1'>
                        <ClockGrid time={timeNow.ToString(HTimeFormat.HMS)} description="GODZINA" />
                        <ClockGrid time={competitionStart.ToString(HTimeFormat.HMS)} description="START" />
                        <ClockGrid time={competitionTime.ToString(HTimeFormat.MMS)} description="CZAS" />
                    </div>
                </div>
            </div>
        </div>
    )
}
export function ClockGrid(props) {
    return (
        <>
            <div className='text-right content-center text-blue-800 text-3xl font-bold'>
                {props.time}
            </div>
            <div className='content-center  text-3xl font-bold'>
                {props.description}
            </div>
        </>
    )
}